import React from 'react';
import { Row, Empty, Typography, Tree, Space } from 'antd';
import NivoTreeChart from "../../charts/nivo/NivoTreeChart";
import { SectorIndustryMapping } from "../../Configs/DataMappings";
import { getRandomColor } from "../../utils/colorUtils";
import { DownOutlined } from '@ant-design/icons';



const GicCompositeTree = ({ industries, treeChartProps, height=1000, width='100%'}) => {


  const buildTreeData = () => {
    let treeData = { name: 'Sectors & Industries', children: [] };

    Object.entries(SectorIndustryMapping).forEach(([sectorKey, industryArray]) => {

      let sectorNode = {
        name: sectorKey,
        color: getRandomColor(), // Optional, if you want to customize colors
        children: industryArray.map(industryKey => ({
          // Map each industry to a child node, including its percentage value
          name: industryKey,
          color: getRandomColor(), // Optional, for color customization
          value: (industries[industryKey] * 100).toFixed(1), // Convert decimal to percentage
        })).filter(industryNode => industryNode.value > 0) // Optional, filter out industries with no value
      };

      // Add the sector node to the tree, if it has any children industries
      if (sectorNode.children.length > 0) {
        treeData.children.push(sectorNode);
      }
    });

    return treeData;
  };

  const treeData = buildTreeData();

  const calculateSectorTotal = (industryArray) => {
    return industryArray.reduce((total, industryKey) => total + (industries[industryKey] || 0), 0);
  };

  return (
        <Row className={'p-6'} align={'middle'}>
          <div style={{height, width}}>
              {treeData.children.length > 0 ? (
                  <>
                    <NivoTreeChart data={treeData} {...treeChartProps||{}}  />
                    <Tree
                      style={{maxHeight: 700, overflowY: 'auto'}}
                      showLine
                      switcherIcon={<DownOutlined />}
                      defaultExpandAll
                      treeData={Object.entries(SectorIndustryMapping)
                        .map(([sectorKey, industryArray]) => {
                          const sectorTotal = calculateSectorTotal(industryArray);
                          return {
                            title: (
                              <Space>
                                <Typography.Text strong>{sectorKey}</Typography.Text>
                                <Typography.Text strong>
                                  ({(sectorTotal * 100).toFixed(1)}%)
                                </Typography.Text>
                              </Space>
                            ),
                            key: sectorKey,
                            children: industryArray
                              .filter(industryKey => industries[industryKey] > 0)
                              .sort((a, b) => industries[b] - industries[a])
                              .map(industryKey => ({
                                title: `${industryKey} (${(industries[industryKey] * 100).toFixed(1)}%)`,
                                key: industryKey,
                              })),
                          };
                        })
                        .filter(sector => sector.children.length > 0)
                      }
                    />
                  </>
              ) : (
                <Empty description="No Data Available" />
              )}
          </div>
        </Row>
  );
};

export default GicCompositeTree;
